import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {ApiLocationService} from '@services/api-location/api-location.service';
import {Observable} from 'rxjs';
import {HTTPS_REQUEST_OPTIONS} from '@constants/https-request-options/https-request-options';
import {MenuFavoriteItem} from '@models/sidebar/response/menu-favorite-item';

@Injectable({
  providedIn: 'root'
})
export class LeftMenuFavoriteService {

  private FAVORITES_URL_SUFFIX = '/api/web/base/favorites';
  private ADD_BASE_MENU_FAVORITES_URL_SUFFIX = '/api/web/base/favorites';
  private REMOVE_MENU_FAVORITE_ITEM_URL_SUFFIX = '/api/web/base/favorites/remove';
  private UPDATE_PARENT_URL_SUFFIX = '/api/web/base/favorites/updateParent/:parentId/:parentName/:isParentMachine';

  private readonly BASE_URL: string;

  constructor(private http: HttpClient, private apiLocation: ApiLocationService) {
    this.BASE_URL = this.apiLocation.getLocation();
  }

  public listFavorites(): Observable<any> {
    const url: string = this.BASE_URL + this.FAVORITES_URL_SUFFIX;
    return this.http.get(url, HTTPS_REQUEST_OPTIONS);
  }

  public addMenuItemFavorite(menuItem: MenuFavoriteItem): Observable<any> {
    const request = Object.assign(new MenuFavoriteItem(), menuItem);
    delete request.url;

    const url: string = this.BASE_URL + this.ADD_BASE_MENU_FAVORITES_URL_SUFFIX;
    return this.http.post(url, request, HTTPS_REQUEST_OPTIONS);
  }

  public removeMenuFavoriteItem(menuItemId: string): Observable<any> {
    const url: string = this.BASE_URL + this.REMOVE_MENU_FAVORITE_ITEM_URL_SUFFIX;
    return this.http.post(url, menuItemId, HTTPS_REQUEST_OPTIONS);
  }

  public updateFavoriteItemParent(parentId: string, parentName: string, isParentMachine: boolean, menuFavoriteItemId: string): Observable<any> {
    let url: string = this.BASE_URL + this.UPDATE_PARENT_URL_SUFFIX;
    url = url.replace(':parentId', parentId)
    .replace(':parentName', parentName)
    .replace(':isParentMachine', String(isParentMachine));
    return this.http.post(url, menuFavoriteItemId, HTTPS_REQUEST_OPTIONS);
  }
}
